/**
 * All rights Reserved, Designed By www.feidai.com
 * @Title:  workbench.ts
 * @Package :
 * @author:青瞳科技
 * @date:   2022/1/19 11:31
 * @version V1.0
 * @Copyright: 2020 https://www.feisuan.com Inc. All rights reserved.
 * @Belong To: 青瞳科技
 * 注意：本内容仅限于深圳青瞳科技有限公司内部传阅，除非适用法律要求或书面同意，禁止外泄以及用于其他的商业目的
 */


const approve = [
  /* 企业认证模块路由 */
  {
    path:'/companyInfoForm',
    name:'CompanyInfoForm',
    component: () =>
    import(/* webpackChunkName: "approve" */ "@/views/approve/companyApprove/index.vue"),
    meta: {
      title:'企业认证',
      keepAlive: true,
      deepth: 1
    },
  },
  {
    path:'/faceConfirm',
    name:'FaceConfirm',
    component: () =>
    import(/* webpackChunkName: "approve" */ "@/views/approve/companyApprove/faceConfirm.vue"),
    meta: {
      title:'企业认证',
      keepAlive: true,
      deepth: 2
    },
  },
  {
    path:'/approveFinish',
    name:'ApproveFinish',
    component: () =>
    import(/* webpackChunkName: "approve" */ "@/views/approve/companyApprove/approveFinish.vue"),
    meta: {
      title:'企业认证',
      keepAlive: false,
      deepth: 1
    },
  },
  /* 个人认证模块路由 */
  {
    path: "/userInfoForm",
    name: "UserInfoForm",
    component: () =>
        import(/* webpackChunkName: "approve" */ "@/views/approve/userApprove/index.vue"),
    meta: {
      title: "身份认证",
      keepAlive: true,
      deepth: 1
    },
  },
  /* 已完成企业认证 */
  {
    path:'/companyApproveFinish',
    name:'CompanyApproveFinish',
    component: () =>
    import(/* webpackChunkName: "approve" */ "@/views/approve/companyApprove/companyApproveFinish.vue"),
    meta: {
      title: "企业认证",
      keepAlive: false,
      deepth: 1
    },
  },
    /* 身份认证协议 */
    {
      path:'/approveText',
      name:'ApproveText',
      component: () =>
      import(/* webpackChunkName: "approve" */ "@/views/approve/components/approveText.vue"),
      meta: {
        title: "南瓜头APP身份认证协议",
        keepAlive: false,
        deepth: 2
      },
    },
      /* 认证结果页面 */
    {
        path:'/faceResult',
        name:'FaceResult',
        component: () =>
        import(/* webpackChunkName: "approve" */ "@/views/approve/companyApprove/faceResult.vue"),
        meta: {
          title: "认证结果",
          keepAlive: false,
          deepth: 2
        },
      }
]

export default approve



